module.exports = __webpack_public_path__ + "img/sichtschutz2.0fe55001.png";